export const routes = ["/", "/school/:id/:name", "/second", "/third"];
